var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{staticClass:"icon",class:("icon-" + _vm.nameLowerCased),on:{"click":function($event){return _vm.clickHandler($event)}}},[_c('use',_vm._b({},'use',{'xlink:href': ("#icon-" + _vm.nameLowerCased)},false))])}
var staticRenderFns = []

export { render, staticRenderFns }